import { render, staticRenderFns } from "./ElasticProductList.vue?vue&type=template&id=e7d7b668&"
import script from "./ElasticProductList.vue?vue&type=script&lang=js&"
export * from "./ElasticProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports